<div class="page-content page-fill">
  @if (batches) {
    <div class="grid-fill" style="max-width: 1000px">
      <dx-data-grid
        #batchesGrid
        [keyExpr]="'id'"
        [dataSource]="batches"
        [columnAutoWidth]="false"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onRowPrepared)="onRowPrepare($event)"
        (onCellDblClick)="rowDoubleClick($event)"
        >
        <dxi-column dataField="name" cellTemplate="nameTemplate" width="400">
          <div *dxTemplate="let d of 'nameTemplate'">
            <a [routerLink]="'/giving/batches/' + d.data.id">{{ d.value || '(blank)' }}</a>
          </div>
        </dxi-column>
        @if (appInfo.graafschap) {
          <dxi-column dataField="quickBooksAccount" caption="Acct" width="50"></dxi-column>
        }
        @if (appInfo.graafschap) {
          <dxi-column dataField="bagNumber" caption="Bag" width="50"></dxi-column>
        }
        <dxi-column dataField="totalAmount" dataTye="number" [format]="{ type: 'currency', precision: 2 }" width="125" cssClass="align-right-pad"></dxi-column>
        <dxi-column dataField="date" caption="Date" dataType="date" width="100" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
        <dxi-column dataField="statusName" caption="Status" width="100"></dxi-column>
        <dxi-column dataField="notes" caption="Notes" width="100"></dxi-column>
        <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="batch-list-grid"></dxo-state-storing>
        <dxo-export [enabled]="true"></dxo-export>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-selection [mode]="'multiple'"></dxo-selection>
        <div *dxTemplate="let data of 'toolbarButtons'">
          <button class="btn btn-success" (click)="open(batchesGrid.focusedRowKey)" [disabled]="batchesGrid.instance.getSelectedRowsData().length !== 1" >Open</button>
          @if (!reviewOnly) {
            <button class="btn btn-secondary ms-2" (click)="add()">New</button>
          }
          <button class="btn btn-sm btn-warning ms-2" (click)="toggleShowAll()">{{ showAll ? 'Show Recent' : 'Show All' }}</button>
          <button class="btn btn-sm btn-danger ms-2" (click)="printDepositSlips()" [disabled]="batchesGrid.instance.getSelectedRowsData().length === 0" >Print Deposit Slips</button>
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (batches) {
            <span class="me-3">
              <strong>{{ batchesGrid.instance.totalCount() + ' items' }}</strong>
            </span>
          }
        </div>
      </dx-data-grid>
    </div>
  }
</div>
